<template>
  <div :style="$cmsStyles('c_e8c446d5fbb3')" class="mobile-box">
    <img class="img" v-if="materialType === 'img'" :src="src" alt="">
    <video
      v-else
      preload
      data-autoplay
      autoplay
      loop
      muted
      width="100%"
      :src="src"
      class="mobile-video"
      ref="video"
    ></video>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    src: String,
    materialType: String,
  },
};
</script>

<style lang="less" scoped>
.mobile-box {
  position: relative;
  width: 20.625vw;
  height: 35.989583333333336vw;
  background-image: var(--cms-c_e8c446d5fbb3-f_0001, url("https://mktv-in-cdn.mockuai.com/16252259933744862.png"));
  background-size: cover;
  background-repeat: no-repeat;
  .img, .mobile-video {
    position: absolute;
    z-index: 2;
    left: 2.65625vw;
    top: 3.28125vw;
    width: 13.072916666666666vw;
    height: 28.333333333333332vw;
    border-radius: 1.0416666666666667vw;
    object-fit: cover;
    box-shadow: 21px 10px 64px 0px rgba(0, 0, 0, 0.33);
  }
}
</style>


